import { StorageKeys } from 'keysso/constants/storageKeys';
import { getLocalStorageItem } from 'keysso/mixins/BrowserStorage';

/**
 * Выпадающий список с количеством записей на странице
 * @type {number[]}
 */
const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 150, 200, 500];

/**
 * Количество записей на странице по-дефолту
 * @type {number}
 */
const DEFAULT_ROWS_PER_PAGE = 25;

function getRowsPerPageLimit()
{
    const isRestricted = window.report_is_demo === true || window.is_user_payed === false;

    return isRestricted
        ? DEFAULT_ROWS_PER_PAGE
        : ROWS_PER_PAGE_OPTIONS[ROWS_PER_PAGE_OPTIONS.length - 1];
}

/**
 * Стандартный шаблон пагинации
 * @type {string}
 */
const DEFAULT_PAGINATOR_TEMPLATE = 'FirstPageLink PageLinks LastPageLink JumpToPageInput RowsPerPageDropdown';
/**
 * Стандартный стилизированный шаблон пагинации левой части
 * @type {string}
 */
const DEFAULT_PAGINATOR_LEFT_TEMPLATE = 'FirstPageLink PageLinks LastPageLink JumpToPageInput';
/**
 * Стандартный стилизированный шаблон пагинации правой части
 * @type {string}
 */
const DEFAULT_PAGINATOR_RIGHT_TEMPLATE = 'CurrentPageReport RowsPerPageDropdown';

export class TableHelper
{
    /**
     * Выпадающий список с количеством записей на странице
     * @return {number[]}
     */
    static getRowsPerPageOptions()
    {
        return ROWS_PER_PAGE_OPTIONS.filter(rows => rows <= getRowsPerPageLimit());
    }

    /**
     * Количество записей на странице по-дефолту
     * @return {number}
     */
    static getDefaultRowsPerPage()
    {
        const storedRowsPerPage = getLocalStorageItem(StorageKeys.GLOBAL_TABLE_PER_PAGE) ?? DEFAULT_ROWS_PER_PAGE;

        return Math.min(storedRowsPerPage, getRowsPerPageLimit());
    }

    /**
     * Преобразуем значение сортировки таблицы в значение наших фильтров
     * @param sortValue (1 = asc|-1 = desc)
     * @return {string}
     */
    static getEncodeSortOrder(sortValue)
    {
        return sortValue < 0 ? 'desc' : 'asc';
    }

    /**
     * Преобразуем значение сортировки наших фильтров в значение таблицы
     * @param sortValue (asc = 1|desc = -1)
     * @return {number}
     */
    static getDecodeSortOrder(sortValue)
    {
        return sortValue === 'desc' ? -1 : 1;
    }

    /**
     * Стандартный шаблон пагинации
     * @return {string}
     */
    static getDefaultPaginatorTemplate()
    {
        return DEFAULT_PAGINATOR_TEMPLATE;
    }

    /**
     * Стандартный стилизированный шаблон пагинации левой части
     * @return {string}
     */
    static getPaginatorLeftTemplate()
    {
        return DEFAULT_PAGINATOR_LEFT_TEMPLATE;
    }

    /**
     * Стандартный стилизированный шаблон пагинации правой части
     * @return {string}
     */
    static getPaginatorRightTemplate()
    {
        return DEFAULT_PAGINATOR_RIGHT_TEMPLATE;
    }
}
